import { useTranslation } from 'react-i18next';
import { CheckRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import PopUp from 'shared/components/pop-up/pop-up';

import { useEmergencyAlarmContextProvider } from '../providers/emergency-alarm-provider';

const ResolveEmergencyAlarmButton = () => {
  const { t } = useTranslation('history');

  const {
    handleEmergencyAlarm: updateAlarmStatus,
    isOpen,
    isHandlingEmergencyAlarm: isUpdatingAlarmStatus,
    setIsOpen,
    canHandleEmergencyAlarm,
  } = useEmergencyAlarmContextProvider();

  return (
    canHandleEmergencyAlarm && (
      <>
        <Button loading={isUpdatingAlarmStatus} variant="outlined" startIcon={<CheckRounded />} onClick={() => setIsOpen(true)}>
          {t('details.handleAlarm')}
        </Button>
        <PopUp
          isOpen={isOpen}
          title={t('details.popup.title')}
          body={t('details.popup.body')}
          primaryButtonText={t('details.popup.confirmButton')}
          secondaryButtonText={t('details.popup.backButton')}
          handleOnClose={() => setIsOpen(false)}
          primaryButtonAction={() => updateAlarmStatus()}
          secondaryButtonAction={() => setIsOpen(false)}
          isLoadingPrimaryAction={isUpdatingAlarmStatus}
        />
      </>
    )
  );
};

export default ResolveEmergencyAlarmButton;
